import intitle from "./../Assets/accordion_img/intitle.png";
import inurl from "./../Assets/accordion_img/inurl.png";
import define from "./../Assets/accordion_img/define.png";
import intext from "./../Assets/accordion_img/intext.png";
import site from "./../Assets/accordion_img/site.png";
import phonebook from "./../Assets/accordion_img/phonebook.png";
import maps from "./../Assets/accordion_img/maps.png";
import book from "./../Assets/accordion_img/book.png";
import info from "./../Assets/accordion_img/info.png";
import movie from "./../Assets/accordion_img/movie.png";
import weather from "./../Assets/accordion_img/weather.png";
import related from "./../Assets/accordion_img/related.png";
import link from "./../Assets/accordion_img/link.png";
export const dorkTypesInfo = [
  {
    title: "intitle:",
    content:
      'The "intitle:" dork is used to search for web pages that have a specific word or phrase in their title. This allows you to find pages where the specified keyword is a part of the title. For example, if you search for "intitle:Google," you will find pages with the word "Google" in their title.',
    img: intitle,
  },
  {
    title: "inurl:",
    content:
      'The "inurl:" dork helps you search for web pages that have a specific word or phrase in their URL. This is useful for pinpointing pages based on keywords in their web addresses. For instance, "inurl:news" will retrieve pages with "news" in their URL.',
    img: inurl,
  },
  {
    title: "intext:",
    content:
      'The "intext:" dork is used to search for web pages that contain a specific word or phrase within their main text content. This allows you to find pages where the specified keyword appears in the body of the page. For example, "intext:JavaScript" will locate pages with "JavaScript" in their content.',
    img: intext,
  },
  {
    title: "define:",
    content:
      'The "define:" dork enables you to look up the definition of a word or phrase. This is particularly useful for quick word definitions and explanations. For instance, "define:computer" will provide definitions and related information for the term "computer."',
    img: define,
  },
  {
    title: "site:",
    content:
      'The "site:" dork allows you to narrow your search to a specific website or domain. It helps you find information within a particular site. For example, "site:wikipedia.org AI" will search for "AI" only within Wikipedia pages.',
    img: site,
  },
  {
    title: "phonebook:",
    content:
      'The "phonebook:" dork is used to search for phonebook listings. It helps you find contact information for individuals or businesses in specific locations. For example, "phonebook:John Doe New York" will retrieve phonebook listings for John Doe in New York.',
    img: phonebook,
  },
  {
    title: "maps:",
    content:
      'The "maps:" dork is used to find map-related information. It helps you discover maps and geographical details related to a specific location or place. For instance, "maps:New York" will display map results for New York.',
    img: maps,
  },
  {
    title: "book:",
    content:
      'The "book:" dork allows you to search for books and literature related to a specific topic or keyword. For example, "book:Python programming" will help you find books related to Python programming.',
    img: book,
  },
  {
    title: "info:",
    content:
      'The "info:" dork is used to search for comprehensive information about a specific topic or subject. It helps you retrieve detailed information and resources. For example, "info:SpaceX" will provide in-depth information about SpaceX.',
    img: info,
  },
  {
    title: "movie:",
    content:
      'The "movie:" dork is used to find information about movies, including details about a film, its cast, and reviews. For example, "movie:Inception" will display information about the movie "Inception."',
    img: movie,
  },
  {
    title: "weather:",
    content:
      'The "weather:" dork is used to check the current weather and weather forecasts for a specific location. For example, "weather:New York" will display the weather forecast for New York, including temperature, humidity, and conditions.',
    img: weather,
  },
  {
    title: "related:",
    content:
      'The "related:" dork helps you find websites and pages related to a specific URL or domain. It\'s useful for discovering websites with similar content or themes. For example, "related:google.com" will list websites related to Google.',
    img: related,
  },
  {
    title: "link:",
    content:
      'The "link:" dork is used to search for web pages that link to a specific URL. It allows you to find pages that reference or link to a particular web address. For example, "link:example.com" will find pages that link to "example.com."',
    img: link,
  },
];
